export const GET_CATEGORY_LIST_REQUEST = "GET_CATEGORY_LIST_REQUEST"
export const GET_CATEGORY_LIST_SUCCESS = "GET_CATEGORY_LIST_SUCCESS"
export const ADD_CATEGORY_REQUEST = "ADD_CATEGORY_REQUEST"
export const ADD_CATEGORY_SUCCESS = "ADD_CATEGORY_SUCCESS"
export const STATUS_CATEGORY_REQUEST = "STATUS_CATEGORY_REQUEST"
export const STATUS_CATEGORY_SUCCESS = "STATUS_CATEGORY_SUCCESS"